import { render } from "./RequestList.vue?vue&type=template&id=086780e7&scoped=true"
import script from "./RequestList.vue?vue&type=script&lang=js"
export * from "./RequestList.vue?vue&type=script&lang=js"

import "./RequestList.vue?vue&type=style&index=0&id=086780e7&scoped=true&lang=css"

import exportComponent from "/kaam/build/sicpa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086780e7"]])

export default __exports__